<template>
	<article class="list">
		<page-header>
			<p class="list__total">총 등록 ({{ totalItem }})</p>
		</page-header>
		<managing-section :is-table="true">
			<horizontal-search
				:block-elem="true"
				class="search-by-enter__container"
				@search="search"
				@init="initPage"
			>
				<select-input
					ref="searchType"
					:default-select-value="searchType"
					:select-list="searchTypeList"
					placeholder="입력하세요"
					@change="searchTypeChange"
				/>
				<select-input
					ref="date"
					:use-period="true"
					:default-select-value="date"
					:select-list="dateList"
					@change="dateChange"
				/>
			</horizontal-search>
		</managing-section>
		<managing-section :is-table="true">
			<template slot="infoSection">
				<span class="section__info__left"></span>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						type="button"
						@click="excelDown"
					>
						엑셀 다운로드
					</button>
					<div class="section__info__items">
						<selector
							v-model="staticCode"
							title="문의유형"
							:option-list="staticCodeList"
							@input="search"
						/>
					</div>
					<div class="section__info__items">
						<selector
							v-model="state"
							title="답변상태"
							:option-list="stateList"
							@input="search"
						/>
					</div>
				</div>
			</template>
			<table class="table-main list__table">
				<thead>
					<tr>
						<th class="list__table__no">No</th>
						<th class="list__table__date">접수일</th>
						<th class="list__table__type">문의유형</th>
						<th>문의내용</th>
						<th class="list__table__nickname">문의자</th>
						<th class="list__table__state">답변 상태</th>
						<th class="list__table__date">답변일</th>
						<th class="list__table__admin">관리자</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in list" :key="idx">
						<td>
							<router-link
								:to="`/operation/cs/${item.cs_in.id}?staticCode=${item.cs_in.static_code}`"
								class="link"
								>{{ item.cs_in.id }}</router-link
							>
						</td>
						<td>{{ item.createdAt }}</td>
						<td class="white-space__nowrap">
							{{ item.staticCodeName }}
						</td>
						<td class="text-left">
							<div
								:class="[
									'list__table__content__box content-box',
									{
										'content-box--has-attach':
											item.attachPath,
									},
								]"
							>
								<router-link
									:to="`/operation/cs/${item.cs_in.id}?staticCode=${item.cs_in.static_code}`"
									class="link content-box__link"
								>
									{{ item.cs_in.body || '-' }}
								</router-link>
							</div>
						</td>
						<td class="white-space__nowrap">
							<router-link
								v-if="item.register.nickName"
								:to="`/register/register-info/${item.cs_in.register_id}`"
								target="_blank"
								class="link"
								>{{ item.register.nickName }}</router-link
							>
							<template v-else> 비회원 </template>
						</td>
						<td>{{ item.state }}</td>
						<td>{{ item.createdAtOut }}</td>
						<td>{{ item.adminAccount.nickName || '-' }}</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				slot="pagination"
				:total-item="totalItem"
				:limit="size"
				:offset="offset"
				@to="paging"
			/>
		</managing-section>
	</article>
</template>
<script>
	import { contactChannelList } from '@/constants.js';
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import Util from '@/util';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import Selector from '@/components/Selector.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';

	export default {
		name: 'CsList',
		components: {
			PageHeader,
			ManagingSection,
			HorizontalSearch,
			SelectInput,
			Selector,
			PaginationBox,
		},
		extends: SearchByEnter,
		data() {
			return {
				totalItem: 0,
				searchTypeList: [
					{ value: 'register', name: '문의자' },
					{ value: 'admin', name: '관리자' },
					{ value: 'keyword', name: '문의내용' },
				],
				searchType: 'register',
				register: '',
				admin: '',
				keyword: '',
				dateList: [
					{ value: 'in', name: '접수일' },
					{ value: 'out', name: '답변일' },
				],
				date: 'in',
				start_date: '',
				end_date: '',
				staticCode: null,
				stateList: [
					{ value: null, name: '전체' },
					{ value: '답변대기', name: '대기' },
					{ value: '답변완료', name: '완료' },
				],
				state: null,
				page: 1,
				size: 20,
				list: [],
			};
		},
		computed: {
			...mapState({
				staticCodes: state => state.filter.staticCodes,
			}),
			...mapGetters({
				csStaticCodeList: 'csStaticCodeList',
			}),
			staticCodeList() {
				return [
					{ code: null, name: '전체' },
					...this.csStaticCodeList,
				].map(item => ({ value: item.code, name: item.name }));
			},
			offset() {
				return (this.page - 1) * this.size;
			},
		},
		watch: {
			'$route.query'() {
				this.init();
			},
		},
		mounted() {
			this.init();
		},
		methods: {
			setQuery() {
				const query = {
					page: String(this.page),
					size: String(this.size),
				};
				const searchType = this.searchType;
				if (this.staticCode) query.code = this.staticCode;
				if (this.state) query.state = this.state;
				if (this[searchType]) query[searchType] = this[searchType];
				if (this.start_date)
					query[`${this.date}_start_date`] = this.start_date;
				if (this.end_date)
					query[`${this.date}_end_date`] = this.end_date;
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			search() {
				this.page = 1;
				this.setQuery();
			},
			initPage() {
				this.searchType = 'register';
				this.searchTypeList.forEach(({ value }) => {
					this[value] = '';
				});
				this.$refs.searchType.init();
				this.date = 'in';
				this.start_date = '';
				this.end_date = '';
				this.$refs.date.init();
				this.page = 1;
				this.staticCode = null;
				this.state = null;
				this.setQuery();
			},
			searchTypeChange({ select, input }) {
				this.searchType = select;
				this[select] = input;
			},
			dateChange({ select, from, to }) {
				this.date = select;
				this.start_date = from;
				this.end_date = to;
			},
			setFilter() {
				const query = this.$route.query;
				if (query.page) this.page = Number(query.page);
				if (query.size) this.size = Number(query.size);
				const searchKeyObj = this.searchTypeList.find(
					({ value }) => query[value]
				);
				if (searchKeyObj) {
					const key = searchKeyObj.value;
					this.$refs.searchType.selectModel = this.searchType = key;
					this.$refs.searchType.inputModel = this[key] = query[key];
				}
				const setDate = (type, from, to) => {
					this.$refs.date.selectModel = this.date = type;
					this.$refs.date.changePeriod({
						from: from || '',
						to: to || '',
					});
				};
				if (query.in_start_date || query.in_end_date) {
					setDate('in', query.in_start_date, query.in_end_date);
				} else if (query.out_start_date || query.out_end_date) {
					setDate('out', query.out_start_date, query.out_end_date);
				}
				if (query.state) {
					this.state = query.state;
				}
				if (query.code) {
					this.staticCode = query.code;
				}
			},
			getParams() {
				const params = {
					page: this.page,
					size: this.size,
					static_code: this.staticCode,
					state: this.state,
				};
				params[this.searchType] = this[this.searchType];
				if (this.start_date)
					params[`${this.date}_start_date`] = this.start_date;
				if (this.end_date)
					params[`${this.date}_end_date`] = this.end_date;
				return params;
			},
			getCodeName(code) {
				let codeObj = this.staticCodeList.find(
					item => item.value === code
				);
				if (!codeObj) {
					codeObj = this.staticCodes.find(item => item.code === code);
				}
				return codeObj ? codeObj.name : code;
			},
			async getList() {
				const params = this.getParams();
				const { data } = await this.$axiosSupport.get('/admin/cs', {
					params,
				});
				this.totalItem = data.total_count;
				this.list = data.rows.map(item => {
					item.state =
						item.cs_in.state === '답변완료' ? '완료' : '대기';
					item.createdAt = moment(item.cs_in.created_at).format(
						'YYYY.MM.DD HH:mm:ss'
					);
					item.staticCodeName = this.getCodeName(
						item.cs_in.static_code
					);
					item.createdAtOut = item.cs_out.created_at
						? moment(item.cs_out.created_at).format(
								'YYYY.MM.DD HH:mm:ss'
							)
						: '-';
					item.attachPath = item.cs_in_attach.length
						? item.cs_in_attach[0].path
						: '';
					return item;
				});
			},
			paging({ offset }) {
				this.page = (offset + this.size) / this.size;
				this.setQuery();
			},
			init() {
				this.setFilter();
				this.getList();
			},
			getContactChannelTxt(contactChannel) {
				return contactChannel
					? contactChannelList.find(
							item => item.value === contactChannel
						)?.label ||
							contactChannelList[contactChannelList.length - 1]
								.label
					: '';
			},
			getContactChannelEtcTxt(contactChannel) {
				return contactChannel &&
					contactChannelList.some(
						item => item.value === contactChannel
					)
					? ''
					: contactChannel;
			},
			excelDown() {
				const clickCb = async (params, period) => {
					const { data, config } = await this.$axiosAdmin2.get(
						'/api/cs/list',
						{ params }
					);
					const rows = data.row.map(item => [
						item.cs_in.id,
						(item.created_at = moment(item.cs_in.created_at).format(
							'YYYY.MM.DD HH:mm:ss'
						)),
						(item.static_code = this.getCodeName(
							item.cs_in.static_code
						)),
						item.cs_in.body,
						this.getContactChannelTxt(item.cs_in.contact_channel),
						this.getContactChannelEtcTxt(
							item.cs_in.contact_channel
						),
						item.register.nick_name ?? '비회원',
						(item.state =
							item.cs_in.state === '답변완료' ? '완료' : '대기'),
						(item.created_at = item.cs_out.created_at
							? moment(item.cs_out.created_at).format(
									'YYYY.MM.DD HH:mm:ss'
								)
							: '-'),
						item.admin_account.nick_name || '-',
					]);
					const title = `1대1 문의(${period.replace(/(\s*)/g, '')})_${Date.now()}`;
					Util.getCsv(
						[rows],
						[title],
						[
							[
								'No',
								'접수일',
								'문의유형',
								'문의내용',
								'유입경로',
								'기타',
								'문의자',
								'답변 상태',
								'답변일',
								'관리자',
							],
						],
						`글로우픽_${title}`,
						config.url
					);
				};
				this.$store.commit('modal/toggleModal', {
					id: 'ExcelDownList',
					params: {
						total: this.totalItem,
						type: 'csList',
						params: this.getParams(),
						clickCb,
					},
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.list__total {
		line-height: 24px;
		font-size: 1rem;
	}

	.list__table__no {
		width: 80px;
	}

	.list__table__date {
		width: 160px;
	}

	.list__table__type {
		width: 148px;
	}

	.list__table__nickname {
		width: 168px;
	}

	.list__table__state {
		width: 90px;
	}

	.list__table__admin {
		width: 112px;
	}

	.content-box {
		display: flex;
	}

	.section__info__right {
		align-items: flex-end;
	}

	.content-box--has-attach:after {
		display: block;
		content: '첨부';
		margin-left: 8px;
		padding: 0 8px;
		background: $btn-blue;
		border-radius: 20px;
		flex-shrink: 0;
		line-height: 20px;
		color: white;
	}

	.content-box__link {
		display: block;
		line-height: 20px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>
